import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Shield, Bot } from "lucide-react";

interface AIConsentModalProps {
  open: boolean;
  onConsent: () => void;
  onDecline: () => void;
}

export function AIConsentModal({ open, onConsent, onDecline }: AIConsentModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 rounded-full bg-primary/10">
              <Bot className="h-6 w-6 text-primary" />
            </div>
            <AlertDialogTitle className="text-xl">AI Data Usage</AlertDialogTitle>
          </div>
          <AlertDialogDescription asChild>
            <div className="space-y-4 text-left">
              <p className="text-muted-foreground leading-relaxed">
                To provide AI-powered insights, this app securely sends the text you enter and 
                relevant context to a third-party AI service (OpenAI). This data is used only 
                to generate responses for you and is not used for advertising.
              </p>
              
              <div className="flex items-start gap-2 p-3 rounded-lg bg-secondary/50 border border-border">
                <Shield className="h-5 w-5 text-primary mt-0.5 shrink-0" />
                <p className="text-sm text-foreground">
                  Your privacy is protected. We only send what's needed to power your personalized coaching experience.
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2 mt-4">
          <AlertDialogCancel 
            onClick={onDecline}
            className="w-full sm:w-auto"
          >
            Not Now
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConsent}
            className="w-full sm:w-auto"
          >
            Allow AI Processing
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
